import React from 'react'
import cn from 'classnames'
import { graphql, Link, useStaticQuery } from 'gatsby'
import { Container } from 'react-bootstrap'

import CreatorsMarquee from '~components/CreatorsMarquee'

import * as s from './CreatorsCarousel.module.scss'

const CREATORS_QUERY = graphql`
  query {
    heroJson {
      heroData {
        id
        name
        subscribersCount
        avatarImg
      }
    }
  }
`

const CreatorsCarousel = (className) => {
  const { heroJson } = useStaticQuery(CREATORS_QUERY)
  const { heroData } = heroJson

  return (
    <div id="heroMarquee" className={cn(s.creatorsCarousel, className)}>
      <CreatorsMarquee creators={heroData} />
      <Container className={s.heading}>
        <p className={s.textHeading}>Creators issuing tokens on XCAD.</p>
        <Link to="/creators" aria-label="Learn More" className={s.link}>
          Learn More
        </Link>
      </Container>
    </div>
  )
}

CreatorsCarousel.defaultProps = {
  className: undefined,
}

export default CreatorsCarousel
